module.exports = __webpack_public_path__ + "static/media/Gilroy-Heavy.2b57bf6e.ttf";